/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';
import { slug } from '../../../common';
import ItemList from 'flarum/common/utils/ItemList';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.leaderboard`;
export default class LeaderboardListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view() {
    const {
      user
    } = this.attrs;
    return m("div", {
      className: "LeaderboardListItem"
    }, m(Link, {
      href: app.route.user(user)
    }, this.items().toArray()));
  }
  items() {
    const {
      user,
      position
    } = this.attrs;
    const items = new ItemList();
    items.add('position', m("span", {
      className: "LeaderboardListItem-position"
    }, position.toString().padStart(2, '0')), 100);
    items.add('avatar', m(Avatar, {
      user: user
    }), 70);
    items.add('username', m("div", {
      className: "LeaderboardListItem-username"
    }, username(user), user.lastSeenAt() && user.isOnline() && m("div", {
      className: "UserCard-lastSeen online"
    }, m(Icon, {
      name: "fas fa-circle"
    }), " ", t('core.forum.user.online_text'))), 40);
    items.add('count', m(Tooltip, {
      text: this.tooltipText
    }, m("span", {
      className: "LeaderboardListItem-count"
    }, m(Icon, {
      name: this.icon
    }), abbreviateNumber(this.value))), 10);
    return items;
  }
  get type() {
    return app.leaderboard.activityType;
  }
  get value() {
    const {
      user,
      value
    } = this.attrs;
    return Number.parseInt(value ?? user.activitySummary());
  }
  get tooltipText() {
    if (this.type === 'time_spent') {
      const text = dayjs.duration(this.value, 'minutes').humanize();
      return t(`${prfx}.time_spent_tooltip`, {
        text,
        duration: this.value
      });
    }
    return `${this.value.toLocaleString()} ${t(`${prfx}.nav.${this.type}`)}`;
  }
  get icon() {
    return this.iconMap[this.type];
  }
  get iconMap() {
    return LeaderboardListItem.getIconMap();
  }
  static getIconMap() {
    return {
      exp: 'fas fa-person-hiking',
      discussions: 'far fa-comments',
      comments: 'far fa-comment',
      likes_received: 'far fa-thumbs-up',
      likes_given: 'far fa-thumbs-up',
      time_spent: 'far fa-hourglass-half',
      best_answers: 'fas fa-circle-check',
      upvotes_received: 'far fa-thumbs-up',
      upvotes_given: 'far fa-thumbs-up',
      downvotes_received: 'far fa-thumbs-down',
      downvotes_given: 'far fa-thumbs-down',
      following_tags: 'far fa-star',
      lurking_tags: 'fas fa-star-half-stroke',
      ignoring_tags: 'fas fa-circle-exclamation',
      hiding_tags: 'fas fa-ban',
      following_users: 'fas fa-user-group',
      lurking_users: 'fas fa-user-group',
      followed_by_users: 'fas fa-user-group',
      lurked_by_users: 'fas fa-user-group',
      popular_discussion: 'fas fa-fire'
    };
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/leaderboards/components/LeaderboardListItem', LeaderboardListItem);